module.exports = __webpack_public_path__ + "static/media/Grupo 352@2x.e5056939.png";